/**
 * @generated SignedSource<<8f5236c721451ec560975b2dfffe9e5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ReportCompanyInput = {
  clientMutationId?: string | null;
  companyId: string;
  note?: string | null;
  reasonsIds: string;
};
export type CompanyProfileReportModalReportCompanyMutation$variables = {
  input: ReportCompanyInput;
};
export type CompanyProfileReportModalReportCompanyMutation$data = {
  readonly reportCompany: {
    readonly company: {
      readonly id: string;
      readonly reported: boolean | null;
    } | null;
  } | null;
};
export type CompanyProfileReportModalReportCompanyMutation = {
  response: CompanyProfileReportModalReportCompanyMutation$data;
  variables: CompanyProfileReportModalReportCompanyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReportCompanyPayload",
    "kind": "LinkedField",
    "name": "reportCompany",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CompanyNode",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reported",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyProfileReportModalReportCompanyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanyProfileReportModalReportCompanyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "688421f6257ceef0bad0e04f7c55a05b",
    "id": null,
    "metadata": {},
    "name": "CompanyProfileReportModalReportCompanyMutation",
    "operationKind": "mutation",
    "text": "mutation CompanyProfileReportModalReportCompanyMutation(\n  $input: ReportCompanyInput!\n) {\n  reportCompany(input: $input) {\n    company {\n      id\n      reported\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0276a70836e99719d19f89c16e4bf726";

export default node;
